import request from "@/utils/request";

//图片上传
export function updatePicture(formFile) {
  return request({
    url: '/picture/picture/',
    method: 'post',
    data: formFile
  })
}



// WEBPACK FOOTER //
// ./src/api/picture.js